import ContainerTypeIcon from '@components/icons/CargoTypeIcons/ContainerIcon';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { TransportCountByType } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import clsx from 'clsx';
import React from 'react';

import { getShortCargoForContainer } from '../helpers';

interface ShortResultContainerProps {
  containerParameter: TransportCountByType;
  BaseData: RouteWidgetBaseParameters;
  mainLanguage: string;
}

function ShortResultContainer({
  containerParameter,
  BaseData,
  mainLanguage,
}: ShortResultContainerProps) {
  const containerCargoDescription = getShortCargoForContainer(
    BaseData.containers,
    containerParameter,
    mainLanguage
  );

  return (
    <div className="selection-result-item">
      <div className={clsx('selection-result-item__cargo')}>
        <div className="selection-result-item__icon">
          <ContainerTypeIcon />
        </div>
        <span className="selection-result-item__title">{containerCargoDescription}</span>
      </div>
    </div>
  );
}

export { ShortResultContainer };
